// Import jQuery and make it globally available
import $ from 'jquery'
window.$ = window.jQuery = $

// Import jQuery UJS - it attaches itself to $ automatically
import('jquery-ujs').then(() => {
  console.log('jquery-ujs loaded');
})

import { Turbo } from "@hotwired/turbo-rails"
// Disable Turbo Drive to avoid conflicts with jquery-ujs
Turbo.session.drive = false

// NOTE: Stimulus is loaded separately via vite_javascript_tag 'stimulus' in layouts
// This keeps application.js lighter and allows for more flexible loading

// Import other dependencies
// Note: cocoon and sticky-kit are loaded from vendor/assets via Sprockets-style requires
// You may need to migrate these to npm packages or keep them in vendor/javascript
import _ from 'lodash'
window._ = _

import moment from 'moment'
import 'moment/locale/fi'
import 'moment/locale/sv'
window.moment = moment


import Chart from 'chart.js'
window.Chart = Chart

import Swal from 'sweetalert2/dist/sweetalert2.esm.all.js'
window.Swal = Swal

import { I18n } from "i18n-js";
import translations from '../legacy/translations'

const i18n = new I18n(translations);
i18n.defaultLocale = "fi";
i18n.locale = "fi";
window.i18n = i18n

// Import local modules from assets/javascripts
import '../legacy/navigation'
import '../legacy/stocks'
import '../legacy/autoplay'
import '../legacy/modal'
import '../legacy/charts'
import '../legacy/lineChart'
import '../legacy/pieChart'
import '../legacy/pieChartSingle'
import '../legacy/job_status'
import '../legacy/telia_sign_signing_handler'
import '../legacy/load_more_rounds'
import '../legacy/inactivity_session_timeout_poller'
import '../legacy/dynamic_company_form'
import '../legacy/investment_agreement'
import '../legacy/beneficiary_form'
import '../legacy/vendor/sticky-kit'

// Global utility functions
window.getQueryStringValue = function(key) {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
          encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
          "(?:\\=([^&]*))?)?.*$",
        "i"
      ),
      "$1"
    )
  );
}

window.isIE = function() {
  var ua = navigator.userAgent;
  var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
  return is_ie;
}

// Document ready event handlers
document.addEventListener("turbo:load", function(event) {
  i18n.locale = document.querySelector('html').getAttribute('lang') || 'fi';

  var url = window.location.href;
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      event: "pageView",
      virtualUrl: url,
    });
  }

  if ($("#anchor-errors").length > 0) {
    $("#anchor-errors li").click(function(e) {
      e.preventDefault();

      var input = "#" + this.className;
      var collection = "#" + this.className + "_1";
      var boolean = "#" + this.className + "_true";

      var $anchor;
      if ($(input).length > 0) {
        $anchor = $(input);
      } else if ($(collection).length > 0) {
        $anchor = $(collection);
      } else if ($(boolean).length > 0) {
        $anchor = $(boolean);
      }

      if ($anchor && $anchor.length > 0 && $anchor.offset()) {
        window.scrollTo({
          top: $anchor.offset().top,
          behavior: "smooth",
        });
      }
    });
  }

  var browserDetect = document.getElementById("browserDetect");
  if (browserDetect) {
    if (window.isIE()) {
      browserDetect.style.display = "block";
    } else {
      browserDetect.style.display = "none";
    }
  }
});

function initializeStickyHelp() {
  $(".sticky-help").stick_in_parent({ offset_top: 10 });
}

function initializeModalToggler() {
  $("#hideContent").hide();
  $("#hideClick").click(function() {
    $("#hideContent").slideToggle(200);
    $("body").toggleClass("modalOpen");
  });
}

function initializeShareModalToggler() {
  $(".hideShareClick").click(function(e) {
    e.preventDefault();
    $(".hideShareContent").addClass("hidden");
    $(this)
      .parent()
      .find(".hideShareContent")
      .removeClass("hidden");
  });
}

function initializeGroupFormElements() {
  let groupedCheckBoxes = _.groupBy($("[data-when-checked-show]"), "dataset.whenCheckedShow");
  _.forEach(groupedCheckBoxes, function(g) {
    let checked = _.filter(g, { checked: true });
    let $panel = $($(_.first(g)).data("when-checked-show"));
    if ($(checked).length > 0) {
      _.forEach(checked, function(cb) {
        let $value = $(cb)
          .data("when-value")
          .toString();
        if ($(cb).val() === $value) {
          $panel.show();
          $panel.find("input").prop("disabled", false);
        } else {
          $panel.hide();
          $panel.find("input").prop("disabled", true);
        }
      });
    } else {
      $panel.hide();
      $panel.find("input").prop("disabled", true);
    }
    _.forEach(g, function(el) {
      $(el).on("change", function() {
        $panel = $($(el).data("when-checked-show"));
        let $value = $(el)
          .data("when-value")
          .toString();
        if ($(el).val() === $value) {
          if ($(el).prop("checked")) {
            $panel.show();
            $panel.find("input").prop("disabled", false);
          } else {
            $panel.hide();
            $panel.find("input").prop("disabled", true);
          }
        }
      });
    });
  });

  let groupedRadioButtons = _.groupBy($("[data-when-chosen-show]"), "dataset.whenChosenShow");
  _.forEach(groupedRadioButtons, function(g) {
    let checked = _.find(g, { checked: true });
    let $panel = $($(_.first(g)).data("when-chosen-show"));
    if (checked) {
      let $value = $(checked)
        .data("when-value")
        .toString();
      if ($(checked).val() === $value) {
        $panel.show();
        $panel.find("input").prop("disabled", false);
      } else {
        $panel.hide();
        $panel.find("input").prop("disabled", true);
      }
    } else {
      $panel.hide();
      $panel.find("input").prop("disabled", true);
    }
    _.forEach(g, function(el) {
      $(el).on("change", function() {
        $panel = $($(el).data("when-chosen-show"));
        let $value = $(el)
          .data("when-value")
          .toString();
        if ($(el).val() === $value && $(el).prop("checked")) {
          $panel.show();
          $panel.find("input").prop("disabled", false);
        } else {
          $panel.hide();
          $panel.find("input").prop("disabled", true);
        }
      });
    });
  });
}

function initializeAgreementFormNextButton() {
  $("[data-role='next-section']").click(function(event) {
    event.preventDefault();
    $(this)
      .parents("section.row")
      .next("label")
      .click();
  });
}

function initializeAgreementFormAccordionButton() {
  $("[data-role='form-section']").keydown(function(event) {
    if (event.keyCode === 13) {
      $(this).click();
    }
  });
}

function convertToNumber(value) {
  return value;
}

function calculateInvestmentRatio(startupInvestments, investmentWealth) {
  var ratio = convertToNumber(startupInvestments) / convertToNumber(investmentWealth);
  if (ratio > 0.2) {
    $("#understands_exceeding")
      .show()
      .find("input")
      .prop("disabled", false);
  } else {
    $("#understands_exceeding")
      .hide()
      .find("input")
      .prop("disabled", true);
  }
}

function calculatePersonalInvestmentRatio() {
  var startupInvestments = $("#agreement_customer_startup_investments").val();
  var investmentWealth = $("#agreement_customer_investment_wealth").val();

  if (
    startupInvestments &&
    startupInvestments.length > 0 &&
    investmentWealth &&
    investmentWealth.length > 0
  ) {
    calculateInvestmentRatio(startupInvestments, investmentWealth);
  } else {
    $("#understands_exceeding")
      .hide()
      .find("input")
      .prop("disabled", true);
  }
}

function calculateCompanyInvestmentRatio() {
  var startupInvestments = $("#agreement_company_startup_investments").val();
  var investmentWealth = $("#agreement_company_investment_wealth").val();

  if (
    startupInvestments &&
    startupInvestments.length > 0 &&
    investmentWealth &&
    investmentWealth.length > 0
  ) {
    calculateInvestmentRatio(startupInvestments, investmentWealth);
  } else {
    $("#understands_exceeding")
      .hide()
      .find("input")
      .prop("disabled", true);
  }
}

function calculateAgreementNetWorth() {
  var sum =
    convertToNumber($("#agreement_customer_total_wealth").val()) -
    convertToNumber($("#agreement_customer_total_debts").val());
  $("#agreement_customer_net_total_wealth").val(sum);
}

function calculateUserInformationNetWorth() {
  var sum =
    convertToNumber($("#agreement_user_information_total_wealth").val()) -
    convertToNumber($("#agreement_user_information_total_debts").val());
  $("#agreement_user_information_net_total_wealth").val(sum);
}

function redirectToMemoDownloadIfNeeded() {
  if (window.location.search.match(/download/)) {
    window.location = $(
      "[data-action='download-memo-" + window.getQueryStringValue("download") + "']"
    ).attr("href");
  }
}

function addInputMaxValidation() {
  const inputField = document.querySelector("[data-maxlength]");

  if (inputField) {
    const maxLength = parseInt(inputField.dataset.maxlength, 10);
    inputField.addEventListener("input", function () {
      if (inputField.value.length > maxLength) {
        inputField.value = inputField.value.substring(0, maxLength);
      }
    });
  }
}

$(document).on("turbo:load", function() {
  initializeStickyHelp();
  initializeModalToggler();
  initializeShareModalToggler();
  initializeGroupFormElements();
  initializeAgreementFormNextButton();
  initializeAgreementFormAccordionButton();
  $("#changedRadioIdName")
    .children('input[name="accordion-group"]')
    .attr("id", "");

  if (
    $("#agreement_customer_startup_investments").length &&
    $("#agreement_customer_investment_wealth").length
  ) {
    calculatePersonalInvestmentRatio();
    $("#agreement_customer_investment_wealth, #agreement_customer_startup_investments").on(
      "change",
      function(e) {
        calculatePersonalInvestmentRatio();
      }
    );
  }

  if (
    $("#agreement_company_startup_investments").length &&
    $("#agreement_company_investment_wealth").length
  ) {
    calculateCompanyInvestmentRatio();
    $("#agreement_company_investment_wealth, #agreement_company_startup_investments").on(
      "change",
      function(e) {
        calculateCompanyInvestmentRatio();
      }
    );
  }

  calculateAgreementNetWorth();

  $("#agreement_customer_total_wealth, #agreement_customer_total_debts").on("change", function(e) {
    calculateAgreementNetWorth();
  });

  initializeFlashMessageAutoHide();

  $("#customerInformationForm").on(
    "keypress",
    ":input:not(textarea):not([type=submit]):not(button)",
    function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    }
  );

  $("#changedRadioIdName").on(
    "keypress",
    ":input:not(textarea):not([type=submit]):not(button)",
    function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    }
  );

  if (typeof KR !== 'undefined' && !KR.allow_skipping_signing) {
    $(".customer_agreement_signing_button").hide();
    $(".customer_agreement_signing_button form").submit();
  }

  redirectToMemoDownloadIfNeeded();
  addInputMaxValidation();
  initializePrivatePlacementExternalLink();

  if (
    $("#agreement_user_information_total_wealth").length &&
    $("#agreement_user_information_total_debts").length
  ) {
    calculateUserInformationNetWorth();

    $("#agreement_user_information_total_wealth, #agreement_user_information_total_debts").on(
      "change",
      function (e) {
        calculateUserInformationNetWorth();
      }
    );
  }

  $("#signing_rights_business_id").keyup(function() {
    let matches = /^\d{7}-\d{1}$/.test(this.value);
    if (matches) {
      $("#signing_rights_submit").prop("disabled", false);
      $("#business_id_error").text("")
    } else {
      $("#signing_rights_submit").prop("disabled", true);
      $("#business_id_error").text("Tarkista Y-tunnus")
    }
  })
});

function initializePrivatePlacementExternalLink() {
  $(document).on("click", "[data-private-placement-external-link]", function (event) {
    event.preventDefault();
    event.stopPropagation();
    var url = $(this).data("private-placement-external-link");
    window.open(url, "_blank");
  });
}

function initializeFlashMessageAutoHide() {
  $(".flash").click(function() {
    $(this).fadeOut(300);
  });
}
